import { render, staticRenderFns } from "./secret.vue?vue&type=template&id=533f1ec0&scoped=true&"
import script from "./secret.vue?vue&type=script&lang=js&"
export * from "./secret.vue?vue&type=script&lang=js&"
import style0 from "./secret.vue?vue&type=style&index=0&id=533f1ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f1ec0",
  null
  
)

export default component.exports